import React, { useEffect } from 'react';
import Sidebar from './components/Layout/Sidebar';
import CommandBar from './components/Layout/CommandBar';
import MainView from './components/FileList/MainView';
import FolderPickerModal from './components/UI/FolderPickerModal';
import ShareModal from './components/UI/ShareModal';
import InitTimingPanel from './components/UI/InitTimingPanel';
import { useFileManagerStore } from './store/useFileManagerStore';
import { useKeyboardShortcuts } from './hooks/useKeyboardShortcuts';
import { webRTCService } from '../../core/WebRTCService';
import { eventBus } from '../../core/EventBus';

interface FileManagerProps {
  onClose?: () => void;
  onOpenNewWindow?: () => void;
  /** 当前会话 peerId，用于文件分享时解析 seat */
  peerId?: string;
}

const FileManager: React.FC<FileManagerProps> = ({ onClose, onOpenNewWindow, peerId }) => {
  const { initializeDataChannel, setPeerId } = useFileManagerStore();
  useKeyboardShortcuts();

  // 同步 peerId 到 store，供 ShareModal 解析 seat
  useEffect(() => {
    setPeerId(peerId ?? null);
  }, [peerId, setPeerId]);

  useEffect(() => {
    let cancelled = false;

    const init = async () => {
      // 懒创建：在当前活跃 PC 上创建 fs-rpc 通道（P2P 切换后也能正确创建）
      const channel = await webRTCService.ensureFsRpcChannel();
      if (channel && !cancelled) {
        console.log('[FileManager] fs-rpc channel ready');
        initializeDataChannel(channel);
      }
    };
    init();

    // P2P 切换后通道可能更新，监听事件重新初始化
    const unsub = eventBus.on('webrtc:fsRpcChannel', (dc: RTCDataChannel) => {
      if (!cancelled) {
        console.log('[FileManager] fs-rpc channel updated via event');
        initializeDataChannel(dc);
      }
    });

    return () => {
      cancelled = true;
      unsub();
    };
  }, []);

  return (
    <div className="flex h-full w-full overflow-hidden text-slate-200">
      <Sidebar />
      <div className="flex flex-col flex-1 min-w-0 bg-black/20 backdrop-blur-md border-l border-white/10 relative">
        <CommandBar onClose={onClose} onOpenNewWindow={onOpenNewWindow} />
        <MainView />
        <FolderPickerModal />
        <ShareModal />
      </div>
      <InitTimingPanel />
    </div>
  );
};

export default FileManager;
